document.addEventListener('click', async (e) => {
  const btn = e.target.closest('.js-sample-add');
  if (!btn || btn.disabled) return;
  e.preventDefault();

  const variantId = btn.getAttribute('data-variant-id');
  if (!variantId) return;

  const originalText = btn.textContent;
  btn.disabled = true;
  btn.textContent = 'Toevoegen...';

  try {
    const addRes = await fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    });

    const addData = await addRes.json();
    if (!addRes.ok) throw new Error(addData.description || 'Fout bij toevoegen sample');

    let sectionIds = [];
    document.querySelectorAll('cart-items-component').forEach((item) => {
      if (item instanceof HTMLElement && item.dataset.sectionId) {
        sectionIds.push(item.dataset.sectionId);
      }
    });

    let sectionsJson = {};
    if (sectionIds.length) {
      const sectionsRes = await fetch(`/?sections=${sectionIds.join(',')}`);
      sectionsJson = await sectionsRes.json();
    }

    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          data: {
            source: 'free-samples',
            itemCount: addData.quantity || 1,
            productId: addData.product_id,
            variantId: addData.variant_id,
            sections: sectionsJson,
          },
        },
      })
    );
  } catch (err) {
    console.error('Kon sample niet toevoegen:', err);
    btn.textContent = 'Mislukt';
    setTimeout(() => {
      btn.textContent = originalText;
      btn.disabled = false;
    }, 1500);
  }
});
